  
  const sidePanel = document.getElementById("sidePanel")
  const overlay = document.getElementById("overlay")
  const headerWrapper = document.querySelector(".header-wrapper")
  const marquee = document.querySelector(".marquee")
  const closeButton = document.querySelector('.sidepanelClose');
  
  
  
  
  function openSidePanel() {
    sidePanel.dataset.open = "true"
    sidePanel.style.width = "500px";
    overlay.style.display = 'block';
    marquee.style.display = "none";
    headerWrapper.style.display = "none"
  }

  function closeSidePanel() {
    sidePanel.style.width = "0";
    headerWrapper.style.display = "block"
    overlay.style.display = 'none';
    sidePanel.dataset.open = "false"
    marquee.style.display = "flex"
  }


  document.addEventListener('DOMContentLoaded', function () {
    closeButton.addEventListener('click', () => {
      closeSidePanel()
    });
  });